import React from 'react';
import Component from 'BaseComponent';

export default class Maintenance extends Component {

  render() {
    return (
      <div className="maintenance">
        <article>
          <h1>We&rsquo;ll be back soon!</h1>
          <div>
            <p>
              Sorry for the inconvenience but we&rsquo;re performing some
              maintenance at the moment. If you need to you can
              always <a href="mailto:support@hardypress.com" className="link">contact us</a>,
              otherwise we&rsquo;ll be back online shortly!
            </p>
            <br />
            <br />
            <p>Obviously live sites are unaffected :)</p>
          </div>
        </article>

        <article>
          <p>&mdash; The HardyPress Team</p>
        </article>
        <article>
          <div className="align--center">
            <a href="https://status.hardypress.com" className="Button">Check our system status page</a>
          </div>
        </article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Maintenance.jsx